import { Button } from "reactstrap";
import { callFunctionIfExists } from "../utils/GeneralUtils";
import useKeyEvent from "../hooks/useKeyEvent";
import Constants from "../utils/Constants";

interface AppEmptyStateProps {
  title: string;
  description: string;
  buttonTitle?: string;
  onClick?: () => void;
  icon?: `mdi-${string}`;
  hideIcon?: boolean;
  hideButtonIcon?: boolean;
  buttonDisabled?: boolean;
  className?: string;
  useEnterKey?: boolean;
}

// Basic empty state card for GrowthCloud.
const AppEmptyState = ({
  title,
  description,
  buttonTitle,
  onClick,
  icon,
  hideIcon,
  hideButtonIcon,
  buttonDisabled,
  className = "",
  useEnterKey,
}: AppEmptyStateProps) => {
  return (
    <div
      className={`border border-superlight bg-ultralight rounded p-4 ${className}`}
    >
      {!hideIcon && (
        <i
          className={`mdi ${
            icon ? icon : "mdi-view-dashboard-outline"
          } text-dark`}
          style={{ fontSize: 35 }}
        />
      )}
      <h2 className="mb-2 mt-1">{title}</h2>
      <div style={{ fontWeight: 500, fontSize: 14 }}>{description}</div>
      {buttonTitle && !useEnterKey && (
        <Button
          className="mt-4"
          onClick={() => callFunctionIfExists(onClick)}
          disabled={buttonDisabled}
          color="primary"
        >
          <span className="btn-inner--text">{buttonTitle}</span>
          {!hideButtonIcon && <i className="mdi mdi-arrow-right" />}
        </Button>
      )}
      {buttonTitle && useEnterKey && (
        <EnterButton
          onClick={onClick}
          buttonDisabled={buttonDisabled}
          buttonTitle={buttonTitle}
          hideButtonIcon={hideButtonIcon}
        />
      )}
    </div>
  );
};

function EnterButton({
  onClick,
  buttonDisabled,
  buttonTitle,
  hideButtonIcon,
}: {
  onClick?: () => void;
  buttonDisabled?: boolean;
  buttonTitle: string;
  hideButtonIcon?: boolean;
}) {
  useKeyEvent(onClick, Constants.KEYS.ENTER);

  return (
    <Button
      className="mt-4"
      onClick={() => callFunctionIfExists(onClick)}
      disabled={buttonDisabled}
      color="primary"
    >
      <span className="btn-inner--text">{buttonTitle}</span>
      {!hideButtonIcon && <i className="mdi mdi-arrow-right" />}
    </Button>
  );
}

export default AppEmptyState;
